import { SwitchButton } from "components/switchButton";
import { IFipixAccountItem } from "interfaces";
import moment from "moment";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { isHaveActionPermission } from "utills/helpers";

interface FipixAccountTableProps {
  data?: IFipixAccountItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const FipixAccountTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: FipixAccountTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                Full name
              </th>
              <th scope="col" className="th">
                Username (Email)
              </th>
              <th scope="col" className="th">
                Created at
              </th>
              <th scope="col" className="th">
                Created by
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th">
                <span className="sr-only">Action</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IFipixAccountItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td overflow-x-auto">{item.full_name}</td>
                <td className="td overflow-x-auto">{item.username}</td>
                <td className="td overflow-x-auto">
                  {item.created_at &&
                    moment(item.created_at, "DD/MM/YYYY HH:mm:ss").format(
                      "DD/MM/YYYY HH:mm:ss"
                    )}
                </td>
                <td className="td overflow-x-auto">{item.created_by}</td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("accounts", "fipix", "edit")}
                    onChange={() => _toggleActive(item.id, item.is_active)}
                  />
                </td>
                <td className="td flex justify-end items-end gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <Link to={`/fipix/accounts/${item.id}`} className="w-fit">
                    <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                      <EyeIcon className="w-4 h-4 text-black" />
                    </Button>
                  </Link>
                  {isHaveActionPermission("accounts", "fipix", "edit") ? (
                    <Link
                      to={`/fipix/accounts/${item.id}/edit`}
                      className="w-fit"
                    >
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <PencilIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                  ) : <></>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
